module.exports = "/img/_/_/_/assets/images/creeper/battle/common//15.jpg?a804d4685c11bc377b7120100e2c7e23";